module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-cxc/modal-facturar-recepcion-pago/modal-facturar-recepcion-pago.component.scss
// module id = ./src/app/components/reporte-cxc/modal-facturar-recepcion-pago/modal-facturar-recepcion-pago.component.scss
// module chunks = main